import type { TenantConfig } from '@/types/TenantConfig'

const burgundy = '#9c182f'
const gold = '#e2dfcc'
const lightGold = '#f3f2ec'

export const alamo: TenantConfig = {
  logo: 'assets/alamo/static/logo.png',
  themeOptions: {
    primaryColor: burgundy,
    secondaryColor: burgundy,
    headerBackground: burgundy,
    headerHeight: '110px',
    memberLinksColor: 'white',
    memberLinksColorHover: 'rgba(255, 255, 255, 0.75)',
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
    logoHeight: '64px',
    cartHeaderBackgroundColor: lightGold,
    cartHeaderTextColor: 'black',
    dialog: {
      headerBackground: '#f3f2ec',
    },
    mobileFooter: {
      textColor: '#292929',
      priceTextColor: '#292929',
    },
  },
  teaserImageSize: {
    width: 135,
    height: 135,
  },
  titleInsideContentColumn: true,
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd D MMM @ h:mm A',
    },

    stripeCreditCard: {
      fontFaceStylesheet: 'https://fonts.googleapis.com/css?family=Raleway:400,500,700',
    },
    completedOrdersRoute: {
      completedImage: {
        mobile: 'assets/alamo/static/completed-photo.jpg',
        desktop: 'assets/alamo/static/completed-photo-wide.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      homeRoute: {
        title: 'Log in, sign up or continue as a guest',
        loginTitle: 'Member Login',
        signupTitle: "I don't have a membership - Sign Me Up!",
        guestTitle: "I don't have a membership - Shop as a guest",
        guestButton: 'Shop as a guest',
      },
      membership: {
        title: 'Become a Member',
        renewTitle: 'Renew Your Membership',
      },
      accountLinks: {
        registerLinkLabel: 'Membership',
      },
      checkoutRoute: {
        title: 'Complete Your Order',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a Date',
      },
      selectAvailableSession: {
        title: 'Choose a Time',
      },
      selectTickets: {
        title: 'Choose the number of tickets',
      },
      applyPromoCodes: {
        applyAnotherPromoCodeLabel: 'Add another discount code',
        applyPromoCodeLabel: 'Add discount code',
      },
    },
  },
  customContent: [
    {
      key: 'member-benefits',
      regions: ['home-member-benefits'],
      template: `
        <div>
          <p>Enjoy all that Alamo has to offer:</p>

          <ul>
            <li>Great value</li>
            <li>Support The Alamo</li>
            <li>Exclusive events</li>
            <li>Tax deductible</li>
          </ul>
        </div>
      `,
    },
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
      template: `
        <p>You can shop as a guest without having to register.</p>
      `,
    },
  ],
}
